




























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { IAlertInfo } from "@/types";

@Component
export default class AlertMessage extends Vue {
  name: "AlertMessage";

  @Prop({ required: true })
  public id!: string;

  @Prop({ required: true })
  public alertType!: string;

  @Prop({ required: true })
  public alertList!: Array<IAlertInfo>;

  get alertCount(): number {
    return this.alertList.length;
  }
}
